import { TextInput, Group, Button, Text, Box, Image } from '@mantine/core'
import { useForm } from '@mantine/form'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from 'hooks/useAuth'
import { useNavigate } from 'react-router-dom'
import { validatePassword } from 'utils/password'
import Plan from 'assets/img/plan.png'
import Logo from 'assets/img/ttlogowithnamewhite.svg?react'
import PasswordIcon from 'assets/icons/lock.svg?react'
interface FormValues {
  code: string
  password: string
  confirmPassword: string
}

export const ResetPassword = () => {
  const { resetPassword } = useAuth()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)

  const form = useForm({
    initialValues: {
      code: '',
      password: '',
      confirmPassword: '',
    },
    validate: {
      password: (value) =>
        validatePassword(value) ? null : 'The password must contain one uppercase, one lowercase, a number and at least 8 characters',
      // eslint-disable-next-line quotes
      confirmPassword: (value, values) => (value === values?.password ? null : "Password doesn't match"),
    },
  })

  async function onSubmit(values: FormValues) {
    setIsLoading(true)
    await resetPassword(values.code, values.password)
    setIsLoading(false)
  }

  return (
    <Box display="flex" w="100%">
      <Box w={416} bg="black" p={30} mx="auto" sx={{ borderTopLeftRadius: '4px', borderBottomLeftRadius: '4px', color: 'white' }}>
        <Box sx={{ position: 'absolute', top: '-100px', left: '-70px', right: 0, bottom: 0, height: '100%', width: '100vw' }}>
          <Image src={Plan} alt="plan" height="100%" width="100%" />
        </Box>
        <Logo width={100} height={70} />
        <Box w="100%" pt={150} display="flex" sx={{ flex: 1, alignItems: 'center', justifyContent: 'center', flexFlow: 'column' }}>
          <Text sx={{ fontSize: '35px', lineHeight: '42px', fontWeight: 600 }}>Already have </Text>
          <Text mb={20} sx={{ fontSize: '35px', lineHeight: '42px', fontWeight: 600 }}>
            an account?
          </Text>
          <Text mb={211} sx={{ fontSize: '20px', lineHeight: '24px' }}>
            Welcome back!
          </Text>
          <Button
            variant="filled"
            onClick={() => navigate('/session/login')}
            radius="xxs"
            sx={{
              fontSize: '18px',
              lineHeight: '22px',
              color: 'white',
              fontWeight: 400,
              borderRadius: '4px',
              width: '216px',
              height: '50px',
              borderColor: 'white',
            }}
          >
            Sign in here
          </Button>
        </Box>
      </Box>
      <Box p={30} display="flex" sx={{ flex: 1, justifyContent: 'center', flexFlow: 'column', zIndex: 100 }}>
        <Box mb={30} sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Text size="xl">{t('Authentication.ResetPassword')}</Text>
        </Box>

        <Box mb={50} sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Text size="md">{t('Authentication.InputCode')}</Text>
        </Box>

        <Box display="flex" sx={{ width: '100%', justifyContent: 'center' }}>
          <form onSubmit={form.onSubmit(onSubmit)}>
            <Group mb={10}>
              <TextInput sx={{ flex: 1 }} withAsterisk type="number" label={t('Authentication.Code')} {...form.getInputProps('code')} />
            </Group>
            <Group mb={10}>
              <TextInput
                sx={{ flex: 1 }}
                leftSection={<PasswordIcon width={20} height={20} />}
                withAsterisk
                type="password"
                label={t('User.Password')}
                {...form.getInputProps('password')}
              />
            </Group>

            <Group mb={10}>
              <TextInput
                sx={{ flex: 1 }}
                leftSection={<PasswordIcon width={20} height={20} />}
                withAsterisk
                type="password"
                label={t('User.ConfirmPassword')}
                {...form.getInputProps('confirmPassword')}
              />
            </Group>

            <Group justify="center" sx={{ marginTop: 30 }}>
              <Button radius="xxs" w={208} sx={{ height: 50 }} type="submit" loading={isLoading}>
                <Text sx={{ fontSize: '18px', lineHeight: '22px', fontWeight: 400 }}>{t('Authentication.ResetPassword')}</Text>
              </Button>
            </Group>
          </form>
        </Box>
      </Box>
    </Box>
  )
}
